/* Leira Farming — Pre-lanzamiento
   El formulario conserva el diseño del tema y manda el número al mismo endpoint que usa el
   embed de Kommo (forms.kommo.com/queue/add), en vez de montar el iframe de Kommo.
   Todo lo configurable llega en data-attributes desde sections/coming-soon.liquid. */
(function () {
  'use strict';

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  function collectUtm() {
    var utm = {};
    try {
      var params = new URLSearchParams(window.location.search);
      UTM_KEYS.forEach(function (key) {
        var value = params.get(key);
        if (value) utm[key] = value;
      });
    } catch (e) {}
    return utm;
  }

  // El endpoint de Kommo no manda cabeceras CORS, así que enviamos en modo no-cors: la
  // petición sale, pero la respuesta es opaca y no podemos leer su error_code. Solo
  // distinguimos "no salió de este navegador" de "salió".
  function sendToKommo(form, phone) {
    var endpoint = form.dataset.kommoEndpoint;
    if (!endpoint) return Promise.resolve();

    var data = new FormData();
    data.append('form_id', form.dataset.kommoFormId || '');
    data.append('hash', form.dataset.kommoHash || '');
    data.append('user_origin', JSON.stringify({ ga: {}, utm: collectUtm(), data_source: 'form' }));
    data.append(form.dataset.kommoField, phone);

    return fetch(endpoint, { method: 'POST', mode: 'no-cors', body: data });
  }

  function openWhatsApp(form, digits) {
    var waNumber = (form.dataset.whatsapp || '').replace(/\D/g, '');
    if (!waNumber) return;

    var template = form.dataset.messageTemplate || '';
    var message = template.indexOf('{phone}') !== -1
      ? template.replace('{phone}', digits)
      : template + ' ' + digits;

    window.open(
      'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(message),
      '_blank',
      'noopener,noreferrer'
    );
  }

  // Solo se llama tras un envío real: a quien vuelve y ya tiene la marca en localStorage no
  // se le mueve la página de debajo de los pies.
  function scheduleRedirect(form) {
    var url = form.dataset.redirectUrl;
    if (!url) return;

    var delay = parseFloat(form.dataset.redirectDelay);
    if (!isFinite(delay) || delay < 0) delay = 4;

    setTimeout(function () {
      window.location.href = url;
    }, delay * 1000);
  }

  function initSignup(form) {
    if (form.dataset.bound === '1') return;
    form.dataset.bound = '1';

    var root = form.closest('[data-coming-soon]') || document;
    var input = form.querySelector('[data-signup-input]');
    var honeypot = form.querySelector('[data-signup-honeypot]');
    var errorEl = form.querySelector('[data-signup-error]');
    var doneEl = root.querySelector('[data-signup-done]');
    var submit = form.querySelector('[data-signup-submit]');
    var submitText = form.querySelector('[data-signup-submit-text]');

    var country = form.querySelector('[data-signup-country]');
    var dialEl = form.querySelector('[data-signup-dial]');
    var flagEl = form.querySelector('[data-signup-flag]');

    var defaultDigits = parseInt(form.dataset.digits, 10) || 10;
    var defaultIso = country ? country.dataset.defaultIso : '';
    var storageKey = form.dataset.storageKey || 'leira-notify-sent';
    var sending = false;

    function selectedIso() {
      if (!country) return defaultIso;
      var option = country.options[country.selectedIndex];
      return option ? option.getAttribute('data-iso') : defaultIso;
    }

    function dialCode() {
      return country ? country.value.replace(/\D/g, '') : '';
    }

    // El país preseleccionado tiene un largo exacto conocido. Para el resto solo se puede
    // exigir lo que garantiza E.164: entre 4 y 14 dígitos nacionales, y como mucho 15
    // contando el indicativo. El largo real varía país por país.
    function digitRules() {
      if (selectedIso() === defaultIso) {
        return { min: defaultDigits, max: defaultDigits, exact: true };
      }
      return { min: 4, max: Math.min(14, 15 - dialCode().length), exact: false };
    }

    function syncCountry() {
      var rules = digitRules();
      if (dialEl) dialEl.textContent = '+' + dialCode();
      if (flagEl) flagEl.hidden = selectedIso() !== flagEl.dataset.flagIso;
      if (input) {
        input.maxLength = rules.max;
        input.value = input.value.slice(0, rules.max);
      }
      if (errorEl) errorEl.textContent = '';
    }

    function markDone() {
      form.hidden = true;
      if (doneEl) doneEl.classList.add('is-visible');
    }

    function setSending(on) {
      sending = on;
      if (submit) {
        submit.disabled = on;
        submit.setAttribute('aria-busy', String(on));
      }
      if (submitText) {
        submitText.textContent = on
          ? submit.dataset.sendingLabel || submit.dataset.label
          : submit.dataset.label;
      }
    }

    // Si ya nos dejó su número antes, mostramos el estado de confirmación de una vez.
    try {
      if (localStorage.getItem(storageKey) === '1') markDone();
    } catch (e) {}

    if (country) {
      country.addEventListener('change', syncCountry);
      syncCountry();
    }

    if (input) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(/\D/g, '').slice(0, digitRules().max);
        if (errorEl) errorEl.textContent = '';
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending || !input) return;

      // Honeypot: bots fill hidden fields; humans never do. Bail silently.
      if (honeypot && honeypot.value) {
        if (errorEl) errorEl.textContent = '';
        return;
      }

      var rules = digitRules();
      var digits = input.value.replace(/\D/g, '');
      if (digits.length < rules.min || digits.length > rules.max) {
        if (errorEl) {
          errorEl.textContent = rules.exact
            ? form.dataset.errorMessage || ''
            : form.dataset.genericErrorMessage || form.dataset.errorMessage || '';
        }
        input.focus();
        return;
      }

      setSending(true);
      if (errorEl) errorEl.textContent = '';

      sendToKommo(form, '+' + dialCode() + digits)
        .then(function () {
          try { localStorage.setItem(storageKey, '1'); } catch (err) {}
          openWhatsApp(form, dialCode() + digits);
          markDone();
          scheduleRedirect(form);
        })
        .catch(function () {
          setSending(false);
          if (errorEl) errorEl.textContent = form.dataset.networkErrorMessage || '';
        });
    });
  }

  function initStaff(toggle) {
    if (toggle.dataset.bound === '1') return;
    toggle.dataset.bound = '1';

    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    function open() {
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }

    // Si la contraseña fue incorrecta, dejamos el panel abierto con el error a la vista.
    if (panel.querySelector('[data-staff-error]')) open();

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
      if (!isOpen) {
        var field = panel.querySelector('input');
        if (field) field.focus();
      }
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-signup-form]').forEach(initSignup);
    (scope || document).querySelectorAll('[data-staff-toggle]').forEach(initStaff);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // El editor de temas re-renderiza la sección: hay que volver a enlazar.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
